/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UnitModalCreateMutationVariables = {|
  code: string,
  description: string,
|};
export type UnitModalCreateMutationResponse = {|
  +unitMeasureCreate: ?{|
    +unitMeasure: ?{|
      +id: string,
      +code: string,
      +description: string,
    |}
  |}
|};
export type UnitModalCreateMutation = {|
  variables: UnitModalCreateMutationVariables,
  response: UnitModalCreateMutationResponse,
|};
*/


/*
mutation UnitModalCreateMutation(
  $code: String!
  $description: String!
) {
  unitMeasureCreate(input: {code: $code, description: $description}) {
    unitMeasure {
      id
      code
      description
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "code",
    "type": "String!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "description",
    "type": "String!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "code",
            "variableName": "code"
          },
          {
            "kind": "Variable",
            "name": "description",
            "variableName": "description"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "UnitMeasureCreatePayload",
    "kind": "LinkedField",
    "name": "unitMeasureCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnitMeasureNode",
        "kind": "LinkedField",
        "name": "unitMeasure",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnitModalCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnitModalCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "UnitModalCreateMutation",
    "operationKind": "mutation",
    "text": "mutation UnitModalCreateMutation(\n  $code: String!\n  $description: String!\n) {\n  unitMeasureCreate(input: {code: $code, description: $description}) {\n    unitMeasure {\n      id\n      code\n      description\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b5619103e0b269a3339dcbdfb3500d32';

module.exports = node;
